module.exports = __webpack_public_path__ + "media/5x10.411be6cb.png";